import React from 'react';
import { SizeChoice } from '@gift/attributes-size-core/SizeAttributeOptions';
import { RadioGroup } from '@gift/ui/components/radio-group/RadioGroup';
import { Radio } from '@gift/ui/components/radio-group/Radio';
import { SizeAttributeRadio } from '@gift/attributes-size-website/partials/SizeAttributeRadio';
import { useTranslation } from 'react-i18next';

export const SizeAttributeRadioGroup = ({
    selected, choices, update, hasPreview
}: Props) => {
    const { t } = useTranslation();
    return (
        <RadioGroup>
            {choices.map(c => (
                <Radio key={c.value} value={c.value} label={t(c.label)}
                    active={c.value === selected.value}
                    onClick={() => update(c.value)}>
                    <SizeAttributeRadio {...c} hasPreview={hasPreview} />
                </Radio>
            ))}
        </RadioGroup>
    );
};

type Props = {
    selected: SizeChoice;
    choices: SizeChoice[];
    update: (value: string) => void;
    hasPreview: boolean;
};
